import { typography } from '@joor/design-system'
import styled from 'styled-components/macro'

const Container = styled.div`
  width: 100%;
  margin-bottom: 16px;
  * p {
    font-family: var(--font-family-alpha);
    margin: 0;
    font-size: var(--size-font-small);
    line-height: 16px;
    letter-spacing: var(--letter-spacing-tighter);
  }
  span {
    color: var(--color-primary-400);
    font-family: var(--font-family-alpha);
    font-size: var(--size-font-extrasmall);
    line-height: 12px;
    letter-spacing: var(--letter-spacing-tight);
  }
  .sender {
    font-weight: var(--font-weight-semibold);
  }
  .content {
    ${typography.alpha.primaryActive.body3}
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`

type Props = {
  sender?: string
  content: string
  timeSpan?: string
}

export const MessagesItem = ({
  sender,
  content,
  timeSpan,
}: Props): JSX.Element => (
  <Container>
    <Row>
      {sender && <p className="sender">{sender}</p>}
      {timeSpan && <span>{timeSpan}</span>}
    </Row>

    <p className="content">{content}</p>
  </Container>
)
